module.exports = __webpack_public_path__ + "img/strip-12.0465e984.jpg";